// eslint-disable-next-line import/prefer-default-export
export enum LicenseTypes {
  Owner = 'private-owner',
  Institutional = 'institution',
  Individual = 'individual',
  Organization = 'productbundle',
}
